import { LayoutLegal } from "../components/shared/LayoutLegal";

export const TermsAndConditions = () => {
  return (
    <LayoutLegal>
      <h1>Términos y Condiciones de Uso</h1>

      <h2>1. Aceptación de los términos</h2>
      <p>
        Al acceder y utilizar este sitio web (<strong>Beyond the Code</strong>),
        aceptas quedar vinculado por los presentes Términos y Condiciones de
        Uso, así como por nuestra Política de Privacidad y Política de Cookies.
        Si no estás de acuerdo con alguno de estos términos, te recomendamos no
        utilizar nuestros servicios ni nuestro sitio web.
      </p>

      <h2>2. Uso del sitio web</h2>
      <p>
        El sitio está destinado a proporcionar información sobre nuestros
        programas de formación en desarrollo web. No está permitido utilizar
        este sitio para actividades ilegales, difamatorias, abusivas o que
        infrinjan derechos de terceros.
      </p>

      <h2>3. Propiedad intelectual</h2>
      <p>
        Todos los contenidos del sitio web (textos, imágenes, logotipos, vídeos,
        diseños, código fuente, etc.) están protegidos por derechos de propiedad
        intelectual y son propiedad de <strong>Beyond the Code</strong> o de
        terceros con licencia. Queda prohibida su reproducción total o parcial
        sin autorización previa.
      </p>

      <h2>4. Registro e inscripción</h2>
      <p>
        Al registrarte o inscribirte en alguno de nuestros cursos, te
        comprometes a proporcionar información veraz y actualizada. Nos
        reservamos el derecho de rechazar solicitudes que no cumplan con
        nuestros requisitos.
      </p>

      <h2>5. Enlaces a terceros</h2>
      <p>
        Nuestro sitio puede contener enlaces a sitios web de terceros. No somos
        responsables del contenido, políticas de privacidad ni prácticas de esos
        sitios.
      </p>

      <h2>6. Exención de responsabilidad</h2>
      <p>
        Nos esforzamos por ofrecer información precisa y actualizada, pero no
        garantizamos la exactitud o integridad de los contenidos. No nos
        responsabilizamos por daños directos o indirectos derivados del uso de
        este sitio web.
      </p>

      <h2>7. Modificaciones</h2>
      <p>
        <strong>Beyond the Code</strong> se reserva el derecho de modificar
        estos Términos de Uso en cualquier momento. Las modificaciones serán
        efectivas desde el momento de su publicación en esta página.
      </p>
      <p>
        <strong>Última actualización:</strong> 26.05.2025
      </p>
    </LayoutLegal>
  );
};
